// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h3 {
  margin-top: 25px;
  margin-bottom: 15px;
}

.spacer td {
  height: 1.3em;
  border: none;
}

tr {
  margin-bottom: 8px;
  height: 18px;
}

tr td {
  border-bottom: 1px solid #eee;
}

tr td.editing {
  border-bottom: 1px solid orange;
}

tr.message td {
  border-bottom: none;
  font-size: 87%;
  color: #777;
}

tr.noBottomBorder td {
  border-bottom: none;
}

tr td:first-child {
  font-size: 14px;
  width: 180px;
}

my-date-picker ::ng-deep div.mydp div input {
  font-size: inherit;
}

input {
  border: none;
}

input[type=text] {
  width: 100%;
  border: 0;
  padding: inherit;
}

select {
  background-color: white;
  width: 100%;
  border: 0;
  padding: inherit;
}

select:focus {
  outline: none;
}

tr.actionModify td:last-child {
  vertical-align: middle;
  width: 50px;
}

table {
  width: 100%;
}

.left4 {
  width: calc(100% + 4px);
  position: relative;
  left: -4px;
}

.left4 select {
  width: calc(100% + 4px);
}

.floatLeft16P {
  float: left;
  width: 16.66666%;
}

my-date-picker ::ng-deep div.mydp {
  border: 0;
  height: 15px !important;
}

my-date-picker ::ng-deep div.mydp div.selectiongroup,
my-date-picker ::ng-deep div.mydp div.selectiongroup input,
my-date-picker ::ng-deep div.mydp div.selectiongroup div.selbtngroup {
  height: 15px !important;
  margin: 0;
}

.adminDatePicker {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/app/administration/components/administration-user-form/administration-user-form.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,YAAA;AACJ;;AACA;EACI,kBAAA;EACA,YAAA;AAEJ;;AACA;EACI,6BAAA;AAEJ;;AACA;EACI,+BAAA;AAEJ;;AACA;EACI,mBAAA;EACA,cAAA;EACA,WAAA;AAEJ;;AACA;EACI,mBAAA;AAEJ;;AACA;EACI,eAAA;EACA,YAAA;AAEJ;;AACA;EACI,kBAAA;AAEJ;;AACA;EACI,YAAA;AAEJ;;AACA;EACI,WAAA;EACA,SAAA;EACA,gBAAA;AAEJ;;AAEA;EACI,uBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;AACJ;;AAGA;EACI,aAAA;AAAJ;;AAGA;EACI,sBAAA;EACA,WAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,uBAAA;EACA,kBAAA;EACA,UAAA;AAAJ;;AAGA;EACI,uBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,SAAA;EACA,uBAAA;AAAJ;;AAGA;;;EAGI,uBAAA;EACA,SAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAAJ","sourcesContent":["h3 {\n    margin-top: 25px;\n    margin-bottom: 15px;\n}\n\n.spacer td {\n    height: 1.3em;\n    border: none;\n}\ntr {\n    margin-bottom: 8px;\n    height: 18px;\n}\n\ntr td {\n    border-bottom: 1px solid #eee;\n}\n\ntr td.editing {\n    border-bottom: 1px solid orange;\n}\n\ntr.message td {\n    border-bottom: none;\n    font-size: 87%;\n    color: #777;\n}\n\ntr.noBottomBorder td {\n    border-bottom: none;\n}\n\ntr td:first-child{\n    font-size: 14px;\n    width: 180px;\n}\n\nmy-date-picker ::ng-deep div.mydp div input {\n    font-size: inherit;\n}\n\ninput {\n    border: none;\n}\n\ninput[type=text] {\n    width: 100%;\n    border: 0;\n    padding: inherit;\n\n}\n\nselect {\n    background-color: white;\n    width: 100%;\n    border: 0;\n    padding: inherit;\n\n}\n\nselect:focus {\n    outline: none;\n}\n\ntr.actionModify td:last-child {\n    vertical-align: middle;\n    width: 50px;\n}\n\ntable {\n    width: 100%;\n}\n\n.left4 {\n    width: calc(100% + 4px);\n    position: relative;\n    left: -4px;\n}\n\n.left4 select {\n    width: calc(100% + 4px);\n}\n\n.floatLeft16P {\n    float: left;\n    width: 16.66666%;\n}\n\nmy-date-picker ::ng-deep div.mydp {\n    border: 0;\n    height: 15px !important;\n}\n\nmy-date-picker ::ng-deep div.mydp div.selectiongroup,\nmy-date-picker ::ng-deep div.mydp div.selectiongroup input,\nmy-date-picker ::ng-deep div.mydp div.selectiongroup div.selbtngroup{\n    height: 15px !important;\n    margin: 0;\n}\n\n.adminDatePicker {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
